import { Link, MenuItem, Select, Typography, useTheme } from "@mui/material";
import CoinAvatar from "components/CoinAvatar";
import { Col, Row } from "v2/components/base/Flex/ui";
import { Chain } from "chainConfigs";
import { Value } from "components/Value";
import { PercentageBlock } from "v2/components/NumBlock/ui";

const TradeRowItem = ({ tradeCall, navigateTo }: { tradeCall: any; navigateTo: () => void }) => {
  const { chain, symbol, imageUrl, mentioned, price, performance } = tradeCall;
  const theme = useTheme();

  return (
    <GroupRowContainer navigateTo={navigateTo}>
      <Row section="token-info" type="sc" sx={{ gap: "12px" }} fullWidth>
        <Col section="token-image" type="cc">
          <CoinAvatar
            style={{
              width: "32px",
              height: "32px",
            }}
            badgeStyle={{
              width: "16px",
              height: "16px",
            }}
            iconUri={imageUrl as string}
            chain={chain as Chain}
            size="sm"
          />
        </Col>
        <Col section="token-name" type="ss" textAlign="left" gap="6px">
          <Typography variant="mobile-body-m" sx={{ marginTop: "-2px" }}>
            {symbol}
          </Typography>
          <Typography variant="mobile-body-s" color="text.secondary" sx={{ marginTop: "-2px" }}>
            <Typography variant="mobile-body-s" color="text.secondary" /> {mentioned} Mentioned
          </Typography>
        </Col>
      </Row>
      <Col section="price-performance" type="ce" sx={{ gap: "4px", whiteSpace: "nowrap" }}>
        <Value variant="body-default" value={price} isPrice useFixedDecimals />
        <PercentageBlock percentage={performance} />
      </Col>
    </GroupRowContainer>
  );
};

const GroupRowContainer = ({
  children,
  navigateTo,
}: {
  children: React.ReactNode;
  navigateTo: () => void;
}) => {
  const theme = useTheme();
  return (
    <Row
      type="bc"
      sx={{
        cursor: "pointer",
        padding: "8px",
        border: `1px solid ${theme.palette.surface.silver}33`,
        background: `${theme.palette.surface.silver}33`,
        borderRadius: theme.spacing(1.5),
        gap: "4px",
        maxWidth: "100%",
        minHeight: "80px",
      }}
      fullWidth
      onClick={navigateTo}>
      {children}
    </Row>
  );
};

export default TradeRowItem;
